<template>
  <div id="app">
    <Menu/>
    <!-- 
        <img src="./assets/logo.png">
        <img src="./assets/bg.jpg"> 
    -->
    <keep-alive>
      <router-view/>
    </keep-alive>
    <Footer/>
  </div>
</template>

<script>
import Menu from "./components/elements/Menu";
import Footer from "./components/elements/Footer";
import css from "./assets/style/my.css";

export default {
  name: "App",
  
  data() {
    return {
      msg: "Información del Casíno",
      code: null
    };
  },
  components: {
    Menu: Menu,
    Footer: Footer
  },
};
</script>

<style>
html,
body,
.block {
  height: 100%;
}
body {
  background-color: #f6f6f6;
  font-family: "Raleway", Arial, "sans-serif";
  background-repeat: repeat;
  background-position: left top;
  background-attachment: fixed;
}
.page-footer {
  padding-top: 0px !important;
}

.indicator {
  border-bottom: 4px solid #7f0000 !important;
}
/* Si [el ancho del dispositivo] es menor o igual a 600px , entonces {…} */
@media only screen and (max-width: 600px) {
  body {
    background-image: url("./assets/bg.jpg") !important;
  }
}
/*"Si [el ancho del dispositivo] es mayor o igual a 601px , entonces {…}" */
@media only screen and (min-width: 601px) {
  body {
    background-image: url("./assets/bg_ipad.jpg") !important;
  }
}

/*
  @media only screen and (max-width: 600px) and (min-width: 400px) {...} 
  @media screen and (orientation: landscape) { ... } 
  @media screen and (-webkit-min-device-pixel-ratio: 2) { ... } 
  @media print { ... } 
*/
</style>


// WEBPACK FOOTER //
// src/App.vue